import React from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Box } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { MANAGER_COLORS } from "./managerTheme.js";

const DoctorSelector = ({ doctors, loading, selectedDoctorId, onChange }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: { xs: "100%", md: 280 } }}>
    <PersonOutlineIcon sx={{ color: MANAGER_COLORS.primary, fontSize: 22 }} />
    <FormControl size="small" fullWidth>
      <InputLabel id="doctor-console-manager-doctor-label">Doctor</InputLabel>
      <Select
        labelId="doctor-console-manager-doctor-label"
        label="Doctor"
        value={selectedDoctorId ?? ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        displayEmpty
        sx={{
          bgcolor: "#fafcfd",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: MANAGER_COLORS.border,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: MANAGER_COLORS.primary,
          },
        }}
        endAdornment={loading ? <CircularProgress size={16} sx={{ mr: 3 }} /> : null}
      >
        {!doctors.length && (
          <MenuItem value="" disabled>
            {loading ? "Loading doctors…" : "No doctors available"}
          </MenuItem>
        )}
        {doctors.map((doctor) => (
          <MenuItem key={doctor.doctor_id} value={String(doctor.doctor_id)}>
            {doctor.name ?? doctor.doctor_id}
            {doctor.department ? ` — ${doctor.department}` : ""}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
);

export default DoctorSelector;
